<template>
  <div
    class="full-text-select-content"
    v-if="defaultFilterOrigin.length"
    ref="content"
    :style="{ marginLeft: level === 0 ? 0 : 27 + 'px' }"
  >
    <div
      class="input full-text-para-search"
      v-for="(val, index) in defaultFilterOrigin"
      :key="val.id"
      :style="{ marginLeft: '4px' }"
    >
      <template v-if="!val.result.length">
        <el-tooltip
          popper-class="tooltip-paragraph-content"
          slot="prepend"
          ref="toolFirstTip"
          effect="dark"
          content="可指定段落检索"
          placement="top-end"
        >
          <el-select
            :style="{ width: '144px', color: '#606266' }"
            placeholder="全文"
            v-model="val.keyword"
            clearable
            filterable
            default-first-option
            @change="keywordChange(val)"
          >
            <el-option-group
              v-for="(groupItem, groupIndex) in paragraphArrGroup"
              :key="groupIndex"
              :label="groupItem.groupName"
            >
              <el-option v-for="item in groupItem.data" :key="item.key" :value="item.key" :label="item.value" />
            </el-option-group>
          </el-select>
        </el-tooltip>
        <el-autocomplete
          v-if="val.keyword != 'fullreason.keyword'"
          ref="paraInputRefs"
          v-model="val.value"
          :style="{ width: inputWidth }"
          clearable
          :fetch-suggestions="(str, cb) => cb([true])"
          placeholder="请输入关键词"
          @blur="valueChange(val)"
        >
          <inputTip @addSymbol="e => (val.value = val.value += e)" />
        </el-autocomplete>
        <fetchSelect
          v-else
          v-model="val.value"
          :inputWidth="inputWidth"
          type="案由"
          placeholder="请输入搜索，多个案由为“或”"
        />
        <el-select
          v-model="val.searchLimit"
          :style="{ width: '80px', margin: '0 7px 0 0' }"
          @change="e => searchLimitChange(e, val)"
          :disabled="val.keyword === 'fullreason.keyword' || val.searchLimitDis"
        >
          <el-option v-for="i in optionList" :key="i.value" :value="i.value" :label="i.title" />
        </el-select>
        <el-tooltip ref="toolFirstTip" effect="dark" content="添加条件" placement="top">
          <span class="full-text-operation" @click="addChildHandle(val, defaultFilterOrigin)"
            ><i class="el-icon-circle-plus-outline"></i
          ></span>
        </el-tooltip>
        <span class="full-text-operation" @click="delHandle(val, index)" v-if="showDelIcon"
          ><i class="el-icon-remove-outline"></i
        ></span>
      </template>
      <template v-else>
        <inputItem
          :defaultFilter.sync="val.result"
          :type.sync="val.type"
          :level="level + 1"
          :itemIndex="index"
          :paragraphArrGroup="paragraphArrGroup"
          @emptyChild="delHandle(val, index)"
          @setParent="setParent"
        />
      </template>
    </div>
    <div class="full-text-group-type" v-if="defaultFilterOrigin.length">
      <div slot="reference" class="group-type-btn">
        <span
          @click="changeType('must')"
          class="group-text"
          :class="[defaultFilterOrigin.length > 1 && type === 'must' ? 'active' : '']"
          >且</span
        >
        <span
          @click="changeType('should')"
          class="group-text"
          :class="[defaultFilterOrigin.length > 1 && type === 'should' ? 'active' : '']"
          >或</span
        >
      </div>
    </div>
    <div class="line">
      <span class="line-item line-item-top"></span>
      <span class="line-item line-item-bottom"></span>
    </div>
  </div>
</template>

<script>
import { uniqueId } from 'lodash';
import inputTip from './inputTip';
import fetchSelect from '@/components/fetchSelect';
// 同段同句
const sameParagraphReg = /[-|]/;
// 同篇
const sameArticleReg = /[+\s]/;

export default {
  name: 'inputItem',
  components: { inputTip, fetchSelect },
  data() {
    return {
      //最大级数，目前只需2级
      maxLevel: 1,
      instrumentType: '裁判文书',
      optionList: [
        {
          title: '同篇',
          value: '同篇'
        },
        {
          title: '同段',
          value: '同段'
        },
        {
          title: '同句',
          value: '同句'
        }
      ],
      defaultFilterOrigin: {}
    };
  },
  props: {
    defaultFilter: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      required: false
    },
    level: {
      type: Number,
      default: 0
    },
    paragraphArrGroup: {
      type: Array,
      required: true
    },
    itemIndex: {
      type: Number,
      required: true
    }
  },
  watch: {
    defaultFilterOrigin: {
      handler(val) {
        this.$emit('update:defaultFilter', val);
      },
      deep: true
    },
    defaultFilter: {
      handler(val) {
        this.defaultFilterOrigin = val;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    showDelIcon() {
      const flag = this.defaultFilterOrigin.length === 2 && this.defaultFilterOrigin[0].result.length === 0;
      if (this.level === 0 && flag) {
        return false;
      } else {
        return true;
      }
    },
    inputWidth() {
      return '268' - this.level * 32 + 'px';
    }
  },
  methods: {
    keywordChange(val) {
      if (val.keyword === 'fullreason.keyword') {
        val.value = [];
        val.searchLimit = '同篇';
      } else {
        val.value = val.value instanceof Array ? '' : val.value;
      }
    },
    searchLimitChange(e, val) {
      const text = val.value.trim();
      if (!text) return;
      if ((sameParagraphReg.test(text) && e !== '同篇') || !sameArticleReg.test(text)) {
        this.$confirm('当前检索条件不支持切换至同段、同句，因为检索内容是单个关键词或存在 “|” “-”等符号 。', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning',
          callback: () => {
            val.searchLimit = '同篇';
          }
        });
      }
    },
    valueChange(val) {
      if (typeof val.value === 'string') {
        const text = val.value.trim();
        if (sameParagraphReg.test(text) || !sameArticleReg.test(text)) {
          val.searchLimit = '同篇';
        }
      }
    },
    changeType(type) {
      this.$emit('update:type', type);
      if (this.defaultFilterOrigin.length < 2) {
        this.addPeer(this.defaultFilterOrigin);
      }
    },
    delHandle(val, index) {
      if (this.level === 0 && this.defaultFilterOrigin.length === 2) {
        this.$emit('setTopItem', this.defaultFilterOrigin[0].result);
      } else if (this.level > 0 && this.defaultFilterOrigin.length === 2) {
        this.defaultFilterOrigin.splice(index, 1);
        this.$emit('setParent', this.defaultFilterOrigin[0], this.itemIndex);
        this.defaultFilterOrigin.splice(0, 1);
      } else {
        this.defaultFilterOrigin.splice(index, 1);
      }
    },
    // 设置回显内容到父级
    setParent(e, itemIndex) {
      this.defaultFilterOrigin[itemIndex].keyword = e.keyword;
      this.defaultFilterOrigin[itemIndex].value = e.value;
      this.defaultFilterOrigin[itemIndex].searchLimit = e.searchLimit;
    },
    // 增加同级
    addPeer(item) {
      item.push(this.fetchPeerInfo({ searchLimit: item[0].searchLimit }));
    },
    addChildHandle(item, parentItem) {
      // 如果所有分组还没子集，点击加号是加同级，反之加子集
      const flag = this.defaultFilterOrigin.every(i => i.result.length === 0);
      if (this.level === 0 && flag) {
        this.addPeer(this.defaultFilterOrigin);
      } else if (this.level === this.maxLevel) {
        this.addPeer(parentItem);
      } else {
        item.result = this.fetchChildInfo(item);
        this.valueChange(item);
        item.value = '';
        item.keyword = 'para_content';
        item.searchLimit = '同篇';
      }
    },
    // 增加同级
    fetchPeerInfo(item = {}) {
      return {
        id: `${Date.now()}_${uniqueId()}`,
        value: item.value || '',
        keyword: item.keyword || 'para_content',
        searchLimit: item.searchLimit || '同篇',
        searchLimitDis: false,
        result: [],
        type: 'must'
      };
    },
    // 增加子集
    fetchChildInfo(item = {}) {
      return [this.fetchPeerInfo(item), this.fetchPeerInfo()];
    }
  }
};
</script>

<style lang="scss" scoped>
.full-text-select-content {
  width: 100%;
  display: inline-block;
  box-sizing: border-box;
  position: relative;
  .full-text-para-search {
    display: flex !important;
    align-items: center;
    padding: 4px 0;
    > div {
      margin-right: 4px;
    }
  }

  .full-text-group-type {
    position: absolute;
    left: -18px;
    font-size: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    user-select: none;

    .group-type-btn {
      display: flex;
      flex-direction: column;
      cursor: pointer;

      .group-text {
        color: #999999;
        background-color: #f5f5f5;
        line-height: 20px;
        padding: 0 2px;

        &.active {
          color: #e42626;
          background-color: #ffeaea;
        }
      }

      &.not-allowed {
        cursor: not-allowed;
      }
    }
  }

  .line {
    display: inline-block;
    background: #ddd;
    width: 1px;
    height: 100%;
    position: absolute;
    left: -11px;
    top: 50%;
    transform: translateY(-50%);
    .line-item {
      contain: '';
      display: block;
      height: 1px;
      width: 10px;
      background: #ddd;
      position: relative;
    }
    .line-item-top {
      position: absolute;
      top: 0;
    }
    .line-item-bottom {
      position: absolute;
      bottom: 0;
    }
  }
}

.full-text-operation {
  font-size: 20px;
  color: #a0acc0;
  margin-right: 5px;
  cursor: pointer;
}
</style>
